(function () {
  'use strict';

  function getFormAction(form) {
    var action = form.getAttribute('action') || '/contact';
    return action.split('#')[0];
  }

  function findFeedbackNodes(doc, formId) {
    var sourceForm = formId ? doc.getElementById(formId) : doc.querySelector('form.newsletter-form');
    if (!sourceForm) {
      return { error: null, success: null };
    }

    return {
      error: sourceForm.querySelector(
        '#ContactFooter-error, .footer-minimal__message--error, .newsletter-form__message.form__message:not(.newsletter-form__message--success)'
      ),
      success: sourceForm.querySelector(
        '#ContactFooter-success, .footer-minimal__message--success, .newsletter-form__message--success'
      ),
    };
  }

  function getToastCopy(form) {
    var wrapper =
      form.closest('[data-newsletter-toast-title]') ||
      form.closest('[data-newsletter-toast-message]') ||
      form;

    return {
      title: wrapper.dataset.newsletterToastTitle || 'Tebrikler!',
      message: wrapper.dataset.newsletterToastMessage || ((document.documentElement.lang || '').indexOf('en') === 0 ? 'Thank you for subscribing' : 'Abone olduğunuz için teşekkür ederiz'),
      closeLabel: wrapper.dataset.newsletterToastClose || 'Close',
    };
  }

  function hideNewsletterToast(toast) {
    if (!toast) return;
    toast.classList.remove('is-visible');
    window.setTimeout(function () {
      toast.remove();
    }, 300);
  }

  function showNewsletterToast(form) {
    var copy = getToastCopy(form);
    var existing = document.querySelector('.newsletter-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'newsletter-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML =
      '<div class="newsletter-toast__inner">' +
      '<p class="newsletter-toast__title">' +
      copy.title +
      '</p>' +
      '<p class="newsletter-toast__message">' +
      copy.message +
      '</p>' +
      '</div>' +
      '<button type="button" class="newsletter-toast__close" aria-label="' +
      copy.closeLabel +
      '">&times;</button>';

    document.body.appendChild(toast);

    var closeButton = toast.querySelector('.newsletter-toast__close');
    closeButton.addEventListener('click', function () {
      hideNewsletterToast(toast);
    });

    window.requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    window.setTimeout(function () {
      hideNewsletterToast(toast);
    }, 5000);
  }

  function clearFeedback(form) {
    form.querySelectorAll('.footer-minimal__message, .newsletter-form__message').forEach(function (node) {
      node.remove();
    });
  }

  function showFeedback(form, node) {
    if (!node) return;
    clearFeedback(form);
    form.appendChild(node);
    node.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    if (typeof node.focus === 'function') {
      node.focus({ preventScroll: true });
    }
  }

  function onSubmit(event) {
    event.preventDefault();

    var form = event.currentTarget;
    if (form.dataset.newsletterSubmitting === 'true') return;

    var submitButton = form.querySelector('[type="submit"]');
    var emailInput = form.querySelector('input[name="contact[email]"]');

    if (!emailInput || !emailInput.value.trim()) {
      if (emailInput) emailInput.focus();
      return;
    }

    form.dataset.newsletterSubmitting = 'true';
    if (submitButton) submitButton.disabled = true;

    fetch(getFormAction(form), {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: {
        Accept: 'text/html',
      },
    })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var feedback = findFeedbackNodes(doc, form.id);

        if (feedback.success) {
          showFeedback(form, feedback.success.cloneNode(true));
          showNewsletterToast(form);
          emailInput.value = '';
          return;
        }

        if (feedback.error) {
          showFeedback(form, feedback.error.cloneNode(true));
          emailInput.focus();
          return;
        }

        // If Shopify redirected back to the page, the parsed doc may contain
        // the updated form markup without separate message ids yet.
        var parsedForm = doc.getElementById(form.id);
        if (parsedForm) {
          var fallbackSuccess = parsedForm.querySelector(
            '.footer-minimal__message--success, .newsletter-form__message--success'
          );
          if (fallbackSuccess) {
            showFeedback(form, fallbackSuccess.cloneNode(true));
            showNewsletterToast(form);
            emailInput.value = '';
          }
        }
      })
      .catch(function () {
        form.removeEventListener('submit', onSubmit);
        form.submit();
      })
      .finally(function () {
        delete form.dataset.newsletterSubmitting;
        if (submitButton) submitButton.disabled = false;
      });
  }

  function initNewsletterForms() {
    document.querySelectorAll('form.newsletter-form').forEach(function (form) {
      if (form.dataset.newsletterEnhanced === 'true') return;
      form.dataset.newsletterEnhanced = 'true';
      form.addEventListener('submit', onSubmit);
    });

    var successMessage = document.getElementById('ContactFooter-success');
    if (successMessage) {
      var form = successMessage.closest('form.newsletter-form');
      if (form) showNewsletterToast(form);
      successMessage.scrollIntoView({ block: 'center', behavior: 'smooth' });
      successMessage.focus({ preventScroll: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewsletterForms);
  } else {
    initNewsletterForms();
  }

  document.addEventListener('shopify:section:load', initNewsletterForms);
})();
